const locale = {
  SESSION_TIMEOUT_WARNING_TITLE: 'Session Timeout Warning',
  SESSION_TIMEOUT_WARNING_DESCRIPTION: 'Your session will expire in 5 minutes due to inactivity.',
};

export default locale;
